export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            了解黑料在线背后的故事与使命
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 border border-background-200/60">
          <div className="flex flex-col gap-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              <strong className="text-foreground-950 font-heading">黑料在线</strong>成立于2024年，是国内领先的黑料视频聚合与在线观看平台。我们致力于为全网吃瓜群众提供最全面、最及时、最高清的黑料视频内容，涵盖网红爆料、明星八卦、综艺揭秘、MCN深挖等热门题材。
            </p>
            <p>
              平台运营团队由资深媒体人和技术专家组成，全天候追踪各大社交平台和内容社区的最新动态，通过智能筛选与人工审核的双重机制，确保每一条黑料视频的真实性与可看性。黑料在线观看无需注册、无需付费，真正做到了零门槛畅享高清内容。
            </p>
            <p>
              截至2026年7月，黑料在线已累计发布黑料视频超过五万条，日均活跃用户突破百万。我们始终秉持"真实、快速、全面"的运营理念，黑料在线播放体验持续优化，致力于成为用户心中最值得信赖的黑料视频在线免费观看平台。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}